export default __webpack_public_path__ + "static/media/opportunity.61fc6b8a.jpg";